import { createContext, useContext } from "react";

export const ApplicationContext = createContext({
  selectedApplication: "",
  setSelectedApplication: () => {},
});

export const useApplication = () => useContext(ApplicationContext);